import { removelocalStorageToken } from "../utilities/sessionStorage/token";
import { removelocalStorageUsername } from "../utilities/sessionStorage/username";
import { useHistory } from "react-router-dom";
import ProductService from "../service/ProductService";
import { useToastContext } from "../contexts/ToastContext/ToastContext";

const useUploadFiles = () => {
  const { showErrorToast } = useToastContext();
  const navigate = useHistory();

  const productService = new ProductService();

  async function uploadFile(file) {
    try {
      const res = await productService.postUploadFile(
        localStorage.getItem("__extraconomy_token"),
        file
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        if (res.messageCode === 500000) console.log(res);
        return false;
      } else return res.result;
    } catch (e) {
      if (e.status === 401) {
        removelocalStorageToken();
        removelocalStorageUsername();
        navigate.push("/login");
      } else if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadFile" });

      console.log(e);
    }
  }

  async function uploadAudio(audio) {
    try {
      const res = await productService.postUploadAudio(
        localStorage.getItem("__extraconomy_token"),
        audio
      );

      if (res.messageCode !== 200000) {
        showErrorToast({ code: res.messageCode });
        if (res.messageCode === 500000) console.log(res);
        return false;
      } else {
        return res.result;
      }
    } catch (e) {
      if (e.status === 401) {
        removelocalStorageToken();
        removelocalStorageUsername();
        navigate.push("/login");
      } else if (e.status === 500) showErrorToast({ detail: "unexpectedSystemBehaviour" });
      else showErrorToast({ detail: "unexpectedErrorUploadFile" });

      console.log(e);
    }
  }

  return {
    uploadFile,
    uploadAudio,
  };
};

export default useUploadFiles;
